import React from 'react';

// There's no pinball-machine emoji in Unicode, so this is a small custom glyph
// (cabinet outline, ball, flippers) used in place of one wherever "Machines"
// needs an icon (sidebar nav, MachineBottomNav).
function PinballMachineIcon({ size = 20, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="4" y="2" width="16" height="20" rx="2" stroke={color} strokeWidth="1.8" />
      <line x1="4" y1="12" x2="20" y2="12" stroke={color} strokeWidth="1.2" opacity="0.5" />
      <circle cx="15" cy="7" r="1.6" fill={color} />
      <path d="M7 17.5l3-2.2M17 17.5l-3-2.2" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export default PinballMachineIcon;
